import { Navigate } from 'react-router-dom'
import { FaqsAr } from '../scenes'
import DEFAULT from '../config/default'

const PageFaqs = () => {
    if (DEFAULT.api.countryCode !== 'AR') {
        return <Navigate to="/" replace />
    }
    return <FaqsAr />
}

export default PageFaqs
